'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _ramdaAdjunct = require('ramda-adjunct');

var _scope = require('../const/scope');

var _errors = require('../errors');

var argIsScopeObj = (0, _ramda.compose)((0, _ramda.has)(_scope.SCOPE), _ramda.head);
var argIsObj = (0, _ramda.compose)(_ramdaAdjunct.isPlainObject, _ramda.head);

var expandScope = function expandScope(provider) {
  return function (value) {
    return (0, _ramda.times)((0, _ramda.always)(value), provider.count());
  };
};

var resolveBreakpointsImpl = function resolveBreakpointsImpl(provider) {
  return function (v) {
    return (0, _ramda.cond)([[argIsScopeObj, (0, _ramda.pipe)(_ramda.head, (0, _ramda.prop)(_scope.SCOPE), expandScope(provider), resolveBreakpointsImpl(provider))], [argIsObj, (0, _ramda.compose)(provider.byName, _ramda.head)], [_ramda.T, provider.byIndex]])(v);
  };
};

var resolveBreakpoints = function resolveBreakpoints(provider) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _ramda.tryCatch)(resolveBreakpointsImpl(provider), function (message) {
      return (0, _errors.throwBreakpointError)((0, _errors.invalidBreakpointError)(message, args));
    })(args);
  };
};

exports.default = resolveBreakpoints;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/breakpoints/resolveBreakpoints.js
// module id = 640
// module chunks = 168707334958949